<router-outlet></router-outlet>
<app-navigation-loader></app-navigation-loader>
<app-confirmation-modal></app-confirmation-modal>
<app-update-available-modal></app-update-available-modal>
<app-update-available-banner></app-update-available-banner>

